import { HomeQuality } from '@models/HomeQuality';
import { SalesforceWebToLead } from '@models/SalesforceWebToLead';
import { atom } from 'recoil';

// Home details
export const addressAtom = atom<string | undefined>({
    key: 'addressAtom',
    default: undefined,
});

/**
 * @deprecated
 */
export const googlePlaceIdAtom = atom<string | undefined>({
    key: 'googlePlaceIdAtom',
    default: undefined,
});

export const bathsAtom = atom<number>({
    key: 'bathsAtom',
    default: 2,
});

export const bedroomsAtom = atom<number>({
    key: 'bedroomsAtom',
    default: 2,
});

/**
 * @deprecated
 */
export const sleepsAtom = atom<number>({
    key: 'sleepsAtom',
    default: 6,
});

export const squareFootageAtom = atom<number | undefined>({
    key: 'squareFootageAtom',
    default: undefined,
});

/**
 * @deprecated
 */
export const estimatedMarketValueAtom = atom<number | undefined>({
    key: 'estimatedMarketValueAtom',
    default: undefined,
});

/**
 * @deprecated
 */
export const homeQualityAtom = atom<HomeQuality>({
    key: 'homeQualityAtom',
    default: 'good',
});

// Amenities
/**
 * Eric: Latest ones - Amenities
 */
export const hasPrivateHotTubAtom = atom<boolean>({
    key: 'hasPrivateHotTubAtom',
    default: false,
});

export const hasPrivatePoolAtom = atom<boolean>({
    key: 'hasPrivatePoolAtom',
    default: false,
});
export const hasCommunityHotTubAtom = atom<boolean>({
    key: 'hasCommunityHotTubAtom',
    default: false,
});

export const hasCommunityPoolAtom = atom<boolean>({
    key: 'hasCommunityPoolAtom',
    default: false,
});

export const hasSkiInOutAtom = atom<boolean>({
    key: 'skiInOutAtom',
    default: false,
});

export const hasWaterfrontAtom = atom<boolean>({
    key: 'hasWaterfrontAtom',
    default: false,
});


/**
 * @deprecated
 */
export const hasAirConditioningAtom = atom<boolean>({
    key: 'hasAirConditioningAtom',
    default: false,
});

/**
 * @deprecated
 */
export const hasGymAtom = atom<boolean>({
    key: 'hasGymAtom',
    default: false,
});

export const hasHotTubAtom = atom<boolean>({
    key: 'hasHotTubAtom',
    default: false,
});

export const isPetFriendlyAtom = atom<boolean>({
    key: 'isPetFriendlyAtom',
    default: true,
});

export const hasPoolAtom = atom<boolean>({
    key: 'hasPrivatePoolAtom',
    default: false,
});

export const hasPatioAtom = atom<boolean>({
    key: 'hasPatioAtom',
    default: false,
});


// Surroundings

export const lakefrontAtom = atom<boolean>({
    key: 'lakefrontAtom',
    default: false,
});

export const hasOceanViewAtom = atom<boolean>({
    key: 'hasOceanViewAtom',
    default: false,
});

export const oceanfrontAtom = atom<boolean>({
    key: 'oceanfrontAtom',
    default: false,
});

/**
 * @deprecated
 */
export const riverfrontAtom = atom<boolean>({
    key: 'riverfrontAtom',
    default: false,
});


export const nearMountainsAtom = atom<boolean>({
    key: 'nearMountainsAtom',
    default: false,
});

// Premium Services

export const linenServicesAtom = atom<boolean>({
    key: 'linenServicesAtom',
    default: false,
});

export const smartHomeAtom = atom<boolean>({
    key: 'smarHomeAtom',
    default: false,
});

export const interiorDesignAtom = atom<boolean>({
    key: 'interiorDesignAtom',
    default: false,
});

export const hotTubServiceAtom = atom<boolean>({
    key: 'hotTubServiceAtrom',
    default: false,
});

// Contact

export const firstNameAtom = atom<string | undefined>({
    key: 'firstNameAtom',
    default: undefined,
});

export const lastNameAtom = atom<string | undefined>({
    key: 'lastNameAtom',
    default: undefined,
});

export const phoneAtom = atom<string | undefined>({
    key: 'phoneAtom',
    default: undefined,
});

export const emailAtom = atom<string | undefined>({
    key: 'emailAtom',
    default: undefined,
});

// Salesforce

export const sfWebToLeadAtom = atom<SalesforceWebToLead | undefined>({
    key: 'sfWebToLeadAtom',
    default: undefined,
});